module.exports = __webpack_public_path__ + "img/contact_code_app@2x.1b0f4b18.png";